import React, { useState } from "react";
import { Link } from "react-router-dom";

const BlogsCard = ({ blogs }) => {
  const [visibleBlogs, setVisibleBlogs] = useState(5);
  const loadMore = () => {
    setVisibleBlogs((prev) => prev + 5);
  };
  return (
    <>
      <div className="space-y-6 mt-12">
        {blogs.slice(0, visibleBlogs).map((blog, index) => (
          <Link
            key={index}
            to={`/glowtech-blogs/${blog.slug}`}
            className="block border-b border-gray-200 pb-6 w-full sm:w-11/12 md:w-4/5 lg:w-[70%] mx-auto flex flex-col md:flex-row gap-4 hover:bg-gray-50 transition-colors p-4 "
          >
            {/* Text content */}
            <div className="flex-1">
              <h2 className="text-xl font-semibold text-left text-black">
                {blog.title}
              </h2>
              <p className="text-gray-600 mb-2 text-left">{blog.subtitle}</p>

              <div className="flex flex-wrap gap-2 mb-3">
                {blog.topics.map((topic, i) => (
                  <span
                    key={i}
                    className="px-2 py-1 bg-gray-100 text-gray-800 text-xs rounded-full"
                  >
                    {topic}
                  </span>
                ))}
              </div>

              <div className="flex flex-wrap items-center space-x-2 text-sm text-gray-500">
                <span>{blog.date}</span>
                <span>By</span>
                <span className="text-blue-600">{blog.author.name}</span>
                {blog.author.linkedIn && (
                  <a
                    href={blog.author.linkedIn}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ml-1 text-blue-600 hover:text-blue-800"
                    onClick={(e) => e.stopPropagation()}
                    aria-label={`${blog.author.name}'s LinkedIn profile`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="w-4 h-4 inline"
                    >
                      <path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z" />
                    </svg>
                  </a>
                )}
              </div>
            </div>

            {/* Image */}
            <div className="w-full md:w-32 h-48 md:h-32 mt-4 md:mt-0 flex-shrink-0">
              <img
                src={blog.image || "https://via.placeholder.com/128"}
                alt={blog.title}
                className="w-full h-full object-cover rounded-lg"
                loading="lazy"
              />
            </div>
          </Link>
        ))}
      </div>

      {/* Load More Button */}
      {blogs.length > visibleBlogs && (
        <div className="mt-6 text-center">
          <button
            onClick={loadMore}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
          >
            Load More
          </button>
        </div>
      )}
    </>
  );
};

export default BlogsCard;
